import { TextChip } from "@/toggle-ui-kit/chip";
import { BalanceTypes } from "@/types/enums";

export const BalanceTypeChip = ({
  balanceType,
}: {
  balanceType: BalanceTypes | null;
}) => {
  switch (balanceType) {
    case "DEBIT":
      return (
        <TextChip
          size="large"
          className="border border-solid [border-color:rgba(246,51,154,0.22)] text-pink-500 bg-white"
        >
          차변
        </TextChip>
      );
    case "CREDIT":
      return (
        <TextChip
          size="large"
          className="border border-solid [border-color:rgba(97,95,255,0.22)] text-indigo-500 bg-white"
        >
          대변
        </TextChip>
      );
    default:
      return null;
  }
};
